import { Component, OnInit } from '@angular/core';
import { EditbaseComponent } from '../../editbase.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from 'src/app/services/users/role.service';
import { MessageService } from 'src/app/services/message.service';
import { TranslateService } from '@ngx-translate/core';
import { SubmenuService } from '../../submenu/submenu.service';
import { NavigationNodeRuleService } from 'src/app/services/navigation/navigation-node-rule.service';

@Component({
  selector: 'app-navigation-rule-form',
  templateUrl: './navigation-rule-form.component.html',
  styleUrls: ['./navigation-rule-form.component.less']
})
export class NavigationRuleFormComponent extends EditbaseComponent implements OnInit {


  model:any = {
    User:{
      
    }
    
  };
  activetab :string = "basic-info";

  constructor(private activatedRoute: ActivatedRoute, private router:Router, public navigationNodeRuleService: NavigationNodeRuleService, public messageService:MessageService, 
    public submenuService:SubmenuService, public translate: TranslateService) { 

      super();
    }

  ngOnInit(): void {
    let id = this.activatedRoute.snapshot.params.id;

    if(id>0)
    {
      this.messageService.showLoading();
      this.navigationNodeRuleService.loadById(id).subscribe((data:any) => {
        this.model = data;
        this.messageService.hideLoading();
      });
    }
  }

  setActiveTab(tabName:string){
    this.activetab  = tabName;
  }

  ngAfterViewChecked(){
    this.submenuService.showRecordDetails("/navigation/rules", this);  
  }

  save() {
  this.messageService.showLoading();
   this.navigationNodeRuleService.save(this.model).subscribe((data:any) => {

      this.model = data;
      this.messageService.hideLoading();
      this.messageService.showMessage("Data saved successfuly.", "success");

    });
  }

  delete() {
    this.messageService.showLoading();
    this.navigationNodeRuleService.delete(this.model).subscribe((data:any) => {
      this.messageService.hideLoading();
      this.messageService.showMessage("Data saved successfuly.", "success");
      this.router.navigate(['navigation/rules']);
    },
  err=>{
    this.messageService.hideLoading();
    this.messageService.showMessage("Error deleting.", "error");
  });
  }
}
